import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { 
  Home, 
  Droplets, 
  Brush, 
  Sparkles, 
  Leaf, 
  Shield, 
  RotateCcw, 
  RefreshCw,
  Building,
  Sun,
  Bug,
  Thermometer
} from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const Services = () => {
  useScrollAnimation();
  
  const services = [
    {
      icon: Home,
      title: "Couverture",
      description: "Installation, réparation et entretien de toiture",
      url: "/services/couverture"
    },
    {
      icon: Droplets,
      title: "Zinguerie",
      description: "Pose gouttières, chéneaux, évacuation eaux pluviales",
      url: "/services/zinguerie"
    },
    {
      icon: Brush,
      title: "Peinture Hydrofuge",
      description: "Protection imperméable durable contre l'humidité",
      url: "/services/peinture-hydrofuge"
    },
    {
      icon: Home,
      title: "Façade & Extérieur",
      description: "Nettoyage avec produits Dalep fongicides",
      url: "/services/facade-exterieur"
    },
    {
      icon: Leaf,
      title: "Démoussage",
      description: "Élimination mousses et lichens avec traitement",
      url: "/services/demoussage-toiture"
    },
    {
      icon: Shield,
      title: "Hydrofuge",
      description: "Traitement imperméable protection 8-15 ans",
      url: "/services/hydrofuge-toiture"
    },
    {
      icon: RotateCcw,
      title: "Remplacement Toiture",
      description: "Changement complet avec garantie décennale",
      url: "/services/remplacement-toiture"
    },
    {
      icon: RefreshCw,
      title: "Rénovation",
      description: "Seconde vie à votre toiture",
      url: "/services/renovation-toiture"
    },
    {
      icon: Building,
      title: "Tuile & Ardoise",
      description: "Expertise couverture traditionnelle et moderne",
      url: "/services/tuile-ardoise"
    },
    {
      icon: Sun,
      title: "Pose Velux",
      description: "Lumière naturelle dans vos combles",
      url: "/services/pose-velux"
    },
    {
      icon: Bug,
      title: "Traitement Charpente",
      description: "Protection contre insectes et champignons",
      url: "/services/traitement-charpente"
    },
    {
      icon: Thermometer,
      title: "Isolation",
      description: "Économies et confort thermique",
      url: "/services/isolation-toiture"
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-background via-background-gray to-background relative overflow-hidden">
      {/* Decorative elements with float animation */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16" data-animate>
          <div className="inline-block px-6 py-2 bg-accent/10 text-accent font-semibold rounded-full mb-6 text-sm uppercase tracking-wider animate-bounce-in">
            Expertise
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-primary animate-fade-in">
            Nos Services
          </h2>
          <p className="text-xl text-muted-foreground leading-relaxed animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Découvrez notre gamme complète de services de couverture, 
            de la simple réparation à la rénovation complète.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              data-animate 
              data-animate-delay={index * 50}
              className="border-0 shadow-lg hover:shadow-2xl bg-card group overflow-hidden transition-all duration-500 hover:-translate-y-3 hover-glow card-hover"
            >
              <CardContent className="p-8 relative">
                {/* Gradient background on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-accent/5 to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <div className="mb-6 w-16 h-16 rounded-2xl gradient-primary flex items-center justify-center transition-all duration-500 group-hover:scale-125 group-hover:rotate-12 shadow-lg">
                    <service.icon className="h-8 w-8 text-white transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <h3 className="font-bold text-xl mb-4 text-primary group-hover:text-accent transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground mb-6 text-sm leading-relaxed">
                    {service.description}
                  </p>
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    className="w-full group-hover:bg-accent group-hover:text-white font-semibold transition-all duration-300 hover-scale"
                    asChild
                  >
                    <a href={service.url}>
                      En savoir plus →
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;